/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Vars_HintInputs */

const en_templates_vars_hint = /** @type {(inputs: Templates_Vars_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(available: [student], [tutor], [time], [date], [duration], [balance], [confirmUrl])`)
};

const he_templates_vars_hint = /** @type {(inputs: Templates_Vars_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(משתנים: [student], [tutor], [time], [date], [duration], [balance], [confirmUrl])`)
};

/**
* | output |
* | --- |
* | "(available: [student], [tutor], [time], [date], [duration], [balance], [confirmUrl])" |
*
* @param {Templates_Vars_HintInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_vars_hint = /** @type {((inputs?: Templates_Vars_HintInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Vars_HintInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_vars_hint(inputs)
	return he_templates_vars_hint(inputs)
});